import { Button, Form, Modal, message } from "antd";
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { connect } from "react-redux";
import ModalHeaderText from "../../../common/ModalHeaders/ModalHeaderText";
import TextArea from "../../UiTextArea/TextArea";
import { saveDeactivePartnerDetails } from "../../../redux/DeactivePartner/action";
import useForm from "../../../common/hooks/useForm";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin, notification } from "antd";
import useSession from "../../CustomLogout/useSession";

const DeactivatePartner = ({
  setPartnerRefresh,
  partnerRefresh,
  drawerOpen,
  setDrawerOpen,
  ...props
}) => {
  const handleSessionExpired = useSession();

  const { state, onChangeTextHandler } = useForm();
  const [form] = Form.useForm();

  const [saveLoading, setSaveLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
    setDrawerOpen(true);
  };

  const handleDeactivatePartner = () => {
    // setIsModalVisible(false);
    setSaveLoading(true);
    const deactivateData = {
      partnerFirmId: props.row?.original?.partnerFirmId,
      active: false,
      deactiveReason: state.deactiveReason,
    };

    props
      .saveDeactivePartnerDetails({
        values: deactivateData,
        access_token: props.access_token,
      })
      .then((res) => {
        setSaveLoading(false);
        if (res && res.status === 200) {
          handleCancel();
          setTimeout(() => {
            message.success("User Deactivated");
          }, 2000);
          setPartnerRefresh(true);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            setSaveLoading(false);

            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      })
      .catch((e) => {
        setSaveLoading(false);
      });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setDrawerOpen(false);
    form.resetFields();
  };

  return (
    <div className="deactivate-partner-sec">
      {/* <p
        style={{ cursor: "pointer", color: "#00b1b1" }}
        onClick={() => {
          showModal();
          props.hide && props.hide();
        }}
      >
        Deactivate Partner
      </p> */}

      <Modal
        open={drawerOpen}
        closable={false}
        className="modal-container"
        centered
        footer={null}
      >
        {" "}
        <Form
          autoComplete="off"
          name="deactivatePartner"
          layout="vertical"
          form={form}
          onFinish={handleDeactivatePartner}
        >
          <Row>
            <Col lg={12} xs={12} md={12} sm={12}>
              <Col md={12} className="headre-login">
                <ModalHeaderText LoginHeading="Deactivate Partner" />
              </Col>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col md={12}>
              <p>
                By Clicking on confirm, the partner will be deactivated and will
                not be able to add leads into the system. However his earlier
                leads will still be active and accessible to the Avanse Teams.
              </p>
            </Col>
          </Row>
          <Row className="form-group">
            <Col md={12}>
              <TextArea
                type="text"
                title="Reason of Deactivation"
                id="reasonOfDeactivation"
                maxLength={255}
                placeholder="Enter Reason of Deactivation"
                autoComplete="off"
                className="floating-input floating-textarea"
                rows={4}
                validation={[
                  {
                    required: true,
                    message: "Please Enter Reason of Deactivation",
                  },
                ]}
                name="deactiveReason"
                onChange={onChangeTextHandler}
              />
            </Col>
          </Row>
          <Row className="">
            <Col md={12} className="d-flex justify-content-end">
              {saveLoading && (
                <div className="pr-4 spanner">
                  <Spin
                    size="large"
                    className="pr-4"
                    indicator={<LoadingOutlined style={{ color: "#00d8db" }} />}
                  ></Spin>
                </div>
              )}
              <Button
                className="mr-3"
                htmlType="button"
                type="default"
                onClick={handleCancel}
              >
                CANCEL
              </Button>
              <Button className="" htmlType="submit" type="primary">
                CONFIRM
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    state: state && state.auth,
    access_token: state && state.auth && state.auth.idToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveDeactivePartnerDetails: (data) =>
      dispatch(saveDeactivePartnerDetails(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DeactivatePartner);
